const FALLBACK_MIME_TYPE = 'application/octet-stream';

const MIME_TYPES_BY_EXTENSION = {
  '.bmp': 'image/bmp',
  '.cer': 'application/pkix-cert',
  '.doc': 'application/msword',
  '.docm': 'application/vnd.ms-word.document.macroEnabled.12',
  '.docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  '.dotm': 'application/vnd.ms-word.template.macroEnabled.12',
  '.dotx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
  '.gif': 'image/gif',
  '.heif': 'image/heif',
  '.jpeg': 'image/jpeg',
  '.jpg': 'image/jpeg',
  '.pdf': 'application/pdf',
  '.png': 'image/png',
  '.tif': 'image/tiff',
  '.tiff': 'image/tiff',
  '.txt': 'text/plain',
  '.xlam': 'application/vnd.ms-excel.addin.macroEnabled.12',
  '.xls': 'application/vnd.ms-excel',
  '.xlsb': 'application/vnd.ms-excel.sheet.binary.macroEnabled.12',
  '.xlsm': 'application/vnd.ms-excel.sheet.macroEnabled.12',
  '.xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  '.xltm': 'application/vnd.ms-excel.template.macroEnabled.12',
  '.xltx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
  '.xml': 'application/xml',
  '.xslt': 'application/xslt+xml',
  '.zip': 'application/zip',
};

const normalizeAcceptedFileTypes = acceptedFileTypes => {
  if (!acceptedFileTypes) return [];

  return (Array.isArray(acceptedFileTypes) ? acceptedFileTypes : acceptedFileTypes.split(','))
    .map(fileType => fileType.trim().toLowerCase())
    .filter(Boolean);
};

const formatAcceptedFileTypes = acceptedFileTypes => {
  const fileTypes = normalizeAcceptedFileTypes(acceptedFileTypes);

  if (!fileTypes.length) return undefined;

  const accept = fileTypes.reduce((memo, fileType) => {
    if (fileType.includes('/')) {
      memo[fileType] = memo[fileType] || [];
      return memo;
    }

    const extension = fileType.startsWith('.') ? fileType : `.${fileType}`;
    const mimeType = MIME_TYPES_BY_EXTENSION[extension] || FALLBACK_MIME_TYPE;

    memo[mimeType] = memo[mimeType] || [];

    if (!memo[mimeType].includes(extension)) {
      memo[mimeType].push(extension);
    }

    return memo;
  }, {});

  return Object.keys(accept).length ? accept : undefined;
};

export default formatAcceptedFileTypes;